<template>
  <common-dialog ref="dialog" width="500px" :title="title + '修改运费模板'" :data="data" :form-rules="rules"
    :save-func="saveFunc" @opened="onOpened" show-save-button @closed="onClosed" @close-saved="$emit('close-saved')"
    close-on-saved>
    <template slot="form">
      <el-form-item label="修改模板为" prop="templateId" label-width="100px">
        <el-select v-model="data.templateId" placeholder="请选择模板" clearable>
          <el-option v-for="(i, k) in freightList" :key="k" :label="i.templateName" :value="i.templateId" />
        </el-select>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from '@/components/common/dialog';
import goodsApi from '@/api/pdd/goods';
import tempApi from '@/api/pdd/temp';

export default {
  components: { commonDialog },
  data() {
    return {
      data: { templateId: null },
      rules: { templateId: [{ required: true, message: '请选择运费模板' }] },
      title: '',
      freightList: [],
      details: [],
      isBatch: false,
    }
  },
  methods: {
    openEdit(rows, isBatch) {
      this.isBatch = isBatch;
      this.title = isBatch ? '批量' : '';
      this.$refs.dialog.open();
      this.loading(true);
      this.getTempList().then(() => {
        this.getDetail(rows);
        this.loading(false);
      });
    },
    loading(isLoading) {
      this.$refs.dialog.loading(isLoading);
    },
    getDetail(rows) {
      this.details = rows.map(function (_data) {
        return {
          carousel_gallery: _data.carouselGalleryList,
          cat_id: _data.catId,
          cost_template_id: _data.costTemplateId,
          country_id: _data.countryId,
          detail_gallery: _data.detailGalleryList,
          goods_id: _data.goodsId,
          goods_name: _data.goodsName,
          out_goods_id: _data.outerGoodsId,
          goods_type: _data.goodsType,
          is_folt: _data.isFolt,
          is_pre_sale: _data.isPreSale,
          is_refundable: _data.isRefundable,
          market_price: _data.marketPrice,
          second_hand: _data.secondHand == 1,
          shipment_limit_second: _data.shipmentLimitSecond,
          sku_list: (_data.skuList || []).map(function (x) {
            return {
              is_onsale: x.is_onsale,
              limit_quantity: x.limit_quantity,
              multi_price: x.multi_price,
              out_sku_sn: x.out_sku_sn,
              price: x.price,
              quantity: 0,
              sku_id: x.sku_id,
              spec_id_list: '[' + (x.spec || []).map(function (s) { return s.spec_id }).join(',') + ']',
              thumb_url: x.thumb_url,
              weight: x.weight,
            };
          }),
        };
      });
    },
    getTempList() {
      var self = this;
      return new Promise(function (resolve) {
        tempApi.list().then(function (res) {
          if (res.code === 0) self.freightList = res.data;
          resolve(res);
        });
      });
    },
    saveFunc() {
      var self = this;
      return new Promise(function (resolve, reject) {
        var saveData = {
          dataList: self.details.map(function (x) {
            return {
              ...x,
              cost_template_id: self.data.templateId,
              carousel_gallery: JSON.stringify(x.carousel_gallery),
              detail_gallery: JSON.stringify(x.detail_gallery),
              sku_list: JSON.stringify(x.sku_list),
            };
          })
        };
        goodsApi.put(saveData).then(function (res) {
          if (res.data && res.data.length > 0) {
            var html = '';
            res.data.forEach(function (x) { html += '<div>' + x.errorMsg + '</div>' });
            self.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
            reject({});
          } else {
            resolve({ Code: 0 });
          }
        }).catch(function (err) { reject(err); });
      });
    },
    onOpened() {
      // opened
    },
    onClosed() {

      this.freightList = [];
    },
  }
}
</script>
